import styles from "./css/AlternativeDashboard.module.css";
import GeneralTab from "@/components/tabs/GeneralTabs";
import { useEffect, useState } from "react";
import { DashboardCard } from "@/components/cards/DashboardCard";
import { AlternativeEnergy } from "./AlternativeEnergy";
import { AlternativeElectricty } from "./AlternativeElectricity";
import { AlternativeData } from "@/types/alternative";
import { CompareEnergy } from "./CompareEnergy";
import { CompareElectricity } from "./CompareElectricity";
import { CityData } from "@/types/city";
import { Project } from "@/types";
import { useTranslation } from "react-i18next";
interface AlternativeDashboardProps { 
    checkedAlternatives: Set<AlternativeData>;
    selectedAlternative: AlternativeData;
    isCompare?: boolean;
    city: CityData | null;
    project: Project;
    bestAlternative: AlternativeData;
}

export const AlternativeDashboard = ({checkedAlternatives, selectedAlternative, isCompare = false, city, project, bestAlternative}: AlternativeDashboardProps) => {
      const [selectedTab, setSelectedTab] = useState("energy");
      const { t } = useTranslation('AlternativeDashboard');

      const tabs = [
    {
      name: t('energy'),
      key: "energy",
    },
    {
      name: t('electricalInfrastructure'),
      key: "electricCompany",
    },
  ];


    
    return (
        <div className={styles.container}>
            <DashboardCard 
                cardSize={styles.dashboardCard} 
                className={styles.card} 
                middleTab={false} 
                tabContent={<GeneralTab 
                    tabs={tabs} 
                    activeTab={selectedTab} 
                    onTabChange={setSelectedTab}
                    underlineClassName={styles.underline}
                />}
            children={
                <div className={styles.tabContentContainer}>
                    {selectedTab === "energy" && !isCompare && <AlternativeEnergy alternative={selectedAlternative}/> }
                    {selectedTab === "electricCompany" && !isCompare && <AlternativeElectricty alternative={selectedAlternative} city={city} project={project}/>}
                    {selectedTab === "energy" && isCompare && <CompareEnergy alternatives={checkedAlternatives} bestAlternative={bestAlternative}/> }
                    {selectedTab === "electricCompany" && isCompare && <CompareElectricity alternatives={checkedAlternatives} project={project} bestAlternative={bestAlternative} />}
                </div>
            }
            />
        </div>
    );
}